module.exports = __webpack_public_path__ + "static/media/tripadvisor-en.56f622f8.PNG";